// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as StoryverseHeader$LiteracyplanetClientSxEntry from "./StoryverseHeader.res.mjs";
import * as StoryverseComponents$LiteracyplanetClientSxEntry from "./StoryverseComponents.res.mjs";

function StoryverseNavBar(props) {
  return React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.ScrollPanel.make, {
              children: null
            }, React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.Spacer.make, {}), React.createElement(StoryverseComponents$LiteracyplanetClientSxEntry.HeaderPanel.make, {
                  children: React.createElement(StoryverseHeader$LiteracyplanetClientSxEntry.make, {
                        onClickMissions: props.onClickMissions,
                        onClickAcademy: props.onClickAcademy,
                        onClickWordFlyers: props.onClickWordFlyers,
                        onClickIntrepizine: props.onClickIntrepizine,
                        onClickMyWords: props.onClickMyWords,
                        onClickLibrary: props.onClickLibrary,
                        onClickBog: props.onClickBog,
                        onClickCollections: props.onClickCollections,
                        lockArcade: props.lockArcade,
                        onClickArcade: props.onClickArcade,
                        lockShop: props.lockShop,
                        onClickShop: props.onClickShop,
                        showLibraryLink: props.showLibraryLink,
                        onClickReports: props.onClickReports,
                        onClickLogout: props.onClickLogout,
                        onClickTeacherMode: props.onClickTeacherMode,
                        showTeacherModeWidget: props.showTeacherModeWidget,
                        settingsMenu: props.menu,
                        userName: props.userName
                      })
                }));
}

var make = StoryverseNavBar;

export {
  make ,
}
/* react Not a pure module */
